import { Box, styled, Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from "@mui/material";

const StyledTooltip = styled(MuiTooltip)(() => ({
  // Existing styles
}));
const TooltipContent = styled(Box)(() => ({
  // Existing styles
}));

interface TooltipProps extends MuiTooltipProps {}

export const Tooltip: React.FC<TooltipProps> = ({ children, ...props }) => {
  const tooltipContent = <TooltipContent>{props.title}</TooltipContent>;
  return (
    <StyledTooltip {...props} title={tooltipContent}>
      {children}
    </StyledTooltip>
  );
};

export default Tooltip;
